import { useState } from "react";
import { IconButton, Button, Grid } from "@material-ui/core";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "./../../../global/ModalBase";
import UploadInput from "./../../../global/UploadInput";
import { FDocumentoGrupaltyle } from "./FDocumentoGrupal";
import { ToastMessage } from "../../../global/ToastMessage";
import { getBase64 } from "./../../../utils/fileBase64";
import { useDispatch, useSelector } from "react-redux";
import { cargarComprobanteGrupal, obtenerComprasHistoricoGrupal } from "./../../../ducks/finanzasDuck"
import AttachmentIcon from '@material-ui/icons/Attachment';
import { formatDinero } from "./../../../utils/formatDinero"
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { obtenerVouchers, clearVouchers, eliminarVoucher, dowloadVoucherAction } from "../../../ducks/voucherGruapalDuck";
import IconDowload from "@material-ui/icons/GetApp"
import IconDelete from "@material-ui/icons/Delete"
import { DialogMessage } from "../../../global/DialogMessage";
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
});

const Formulario = (props) => {
    const {
        onClose = () => { },
        Compra = {}
    } = props;
    const { fechaIndividual } = useSelector(store => store.finanzas)
    const dispatch = useDispatch()
    const classes = FDocumentoGrupaltyle()
    const [file, setFile] = useState([]);

    const onGuardar = () => {
        if (file.length > 0) {
            dispatch(onLoadAnction({ message: "" }))
            file.forEach(async (archivo) => {
                await getBase64(archivo).then((result) => {
                    const Logobase64 = String(result).split(",")[1];
                    let payload = {
                        idPagoGrupal: Compra.pagoGrupal?.idPagoGrupal,
                        Nombre: `${archivo.name.split(".")[0]}`,
                        Imagen: Logobase64,
                        ExtensionImagen:
                            archivo.name.split(".")[archivo.name.split(".").length - 1],
                    };
                    dispatch(cargarComprobanteGrupal(payload)).then((Response) => {
                        dispatch(offLoadAction())
                        if (Response.status === 500) {
                            ToastMessage.fire({
                                icon: "error",
                                title: "Ha habido un problema intentar mas tarde",
                            });
                            return null;
                        }
                        if (Response.status === 400) {
                            ToastMessage.fire({
                                icon: "warning",
                                title: Response.Message,
                            });
                            return null;
                        }
                        handleClose();
                        dispatch(obtenerVouchers({ idCompra: Compra.pagoGrupal?.idPagoGrupal, }))
                        dispatch(obtenerComprasHistoricoGrupal({ fecha: fechaIndividual }))
                        ToastMessage.fire({
                            icon: "success",
                            title: "Ingreso Correcto",
                        });
                    });
                });
            });
        } else {
            ToastMessage.fire({
                icon: "warning",
                title: "<strong>Atención</strong>",
                text: "Seleccione por lo menos una imagen.",
            });
        }
    }
    const handleClose = () => {
        onClose(false)
    }
    return (
        <div>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12}>
                    <UploadInput
                        files={file}
                        accept='.pdf,.jpg,.png,.jpeg'
                        isPreview={false}
                        multiple={true}
                        setFiles={setFile}
                    />
                </Grid>
            </Grid>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.modalBotonesCenter}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.modalBoton}
                        onClick={onGuardar}
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>
        </div>
    )
}
const TablaVoucher = () => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const { vouchers, idCompra } = useSelector(store => store.vouchersIndividual)
    const { fechaIndividual } = useSelector(store => store.finanzas)
    const rows = vouchers
    const onDelete = ({ idVoucher }) => {
        DialogMessage.fire({
            title: '¿Estas seguro de eliminar este comprobante?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(eliminarVoucher({ idDocumento: idVoucher })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(obtenerVouchers({ idCompra }))
                    dispatch(obtenerComprasHistoricoGrupal({ fecha: fechaIndividual }))
                    ToastMessage.fire(
                        '¡Se elimino el documento!',
                        '',
                        'success'
                    )
                })
            }
        })
    }
    const onDowload = ({ idVoucher }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(dowloadVoucherAction({ idDocumento: idVoucher })).then(Response => {
            dispatch(offLoadAction())
            if (Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                return null
            }
            if (Response?.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null
            }
            const downloadUrl = window.URL.createObjectURL(new Blob([Response.data], { type: Response.contentType }));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.target = "_blank"
            link.download = `Compra Item ${idVoucher}`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="caption table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Nombre</TableCell>
                        <TableCell align="center">Acción</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.IdCompraGrupalDocumento}>
                            <TableCell align="center" >
                                {row.Nombre}
                            </TableCell>
                            <TableCell align="center">
                                <div>
                                    <IconButton variant="outlined" color="primary" onClick={() => onDelete({ idVoucher: row.IdCompraGrupalDocumento })}>
                                        <IconDelete />
                                    </IconButton>
                                    <IconButton variant="outlined" color="primary" onClick={() => onDowload({ idVoucher: row.IdCompraGrupalDocumento })}>
                                        <IconDowload />
                                    </IconButton>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
const FDocumentoGrupal = (props) => {
    const { Compra, Update } = props
    const classes = FDocumentoGrupaltyle()
    const [open, setOpen] = useState(false)
    const [openForm, setOpenForm] = useState(false)
    const dispatch = useDispatch()
    const onClick = () => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerVouchers({ idCompra: Compra.pagoGrupal?.idPagoGrupal })).then(Resposne => {
            dispatch(offLoadAction())
        })
        setOpen(true)
    }
    const handleClose = () => {
        dispatch(clearVouchers())
        setOpen(false)
    }

    const handleOpenForm = () => {
        setOpenForm(true)
    }
    const handleCloseForm = () => {
        setOpenForm(false)
    }
    return (
        <div>
            <IconButton variant="outlined" onClick={onClick}>
                {(!Update) ? <AttachmentIcon color="primary" /> : <AttachFileIcon color="secondary" />}
            </IconButton>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo="Comprobante pago de Item"
                />
                <div style={{ margin: '10px', display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <p style={{ margin: 0 }}>Motivo: <b>{Compra.compra?.TipoCompra?.Descripcion}</b></p>
                    <p style={{ margin: 0 }}>Operador: <b>{Compra.Proveedor}</b></p>
                    <p style={{ margin: 0 }}>Monto pagado: <b>{`${formatDinero(Compra.pagoGrupal?.Monto * Compra.pagoGrupal?.TipoCambio)}`} {Compra.moneda?.Clave}</b></p>
                </div>
                <div style={{ margin: '10px 0', display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        className={classes.modalBoton}
                        onClick={handleOpenForm}
                    >
                        Cargar comprobante
                    </Button>
                </div>
                <div style={{ height: "10rem", overflowY: "scroll" }}>
                    <TablaVoucher Compra={Compra} />
                </div>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                            onClick={handleClose}
                        >
                            Aplicar
                        </Button>
                    </Grid>
                </Grid>
            </ModalBase>
            <ModalBase classes={classes} open={openForm} onClose={handleCloseForm}>
                <HeaderModal
                    handleClose={handleCloseForm}
                    titulo="Comprobante pago de Item"
                />
                <Formulario Compra={Compra} onClose={handleCloseForm} />
            </ModalBase>
        </div>
    )
}
export default FDocumentoGrupal
